module.exports = __webpack_public_path__ + "9a661a4558f64470063b44f320140c6b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Medium.svg
// module id = 350
// module chunks = 0